import { Typography } from '@mui/material';
import { Link } from '@takeshape/redux-little-router';
import linkTheme from 'app/common/draftjs/link/styles.module.css';
import type React from 'react';
import DocumentTitle from 'react-document-title';
import styled from 'styled-components';
import type { NotFoundErrorContentProps } from './not-found-error-content-hook.js';

const Container = styled('div')`
  padding: ${({ theme }) => theme.spacing(6)};
`;

export const NotFoundErrorContent: React.FC<NotFoundErrorContentProps> = (props) => {
  const { user } = props;
  const linkText = user.get('data') ? 'Projects' : 'Login';

  return (
    <Container>
      <DocumentTitle title="Not Found" />
      <Typography variant="h4" align="center" gutterBottom>
        404
      </Typography>
      <Typography variant="body1" gutterBottom>
        Whoops! Looks like there&#39;s nothing here.
      </Typography>
      <Typography variant="body1" gutterBottom>
        If you believe there is a problem, please contact your project owner.
      </Typography>
      <Typography variant="body1">
        <Link className={linkTheme.link} href="/">
          Back to {linkText}
        </Link>
      </Typography>
    </Container>
  );
};
